__turbopack_context__.v({
  "itemIcon": "NameColumn-module-scss-module__Heu4qa__itemIcon",
  "nameColumnContainer": "NameColumn-module-scss-module__Heu4qa__nameColumnContainer",
  "tableIconStyles": "NameColumn-module-scss-module__Heu4qa__tableIconStyles",
});
